import React from 'react';
import {HtmlRendererProps} from '@/declarations';

/* -------------------- HTML Sanitizer to prevent XSS -------------------- */
export const sanitizeHtml = (html: string): string => {
    if (!html) return '';

    let sanitized = html;

    /* Remove script tags and their content */
    sanitized = sanitized.replace(
        /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,
        '',
    );

    /* Remove event handlers */
    sanitized = sanitized.replace(/\s+on\w+="[^"]*"/gi, '');
    sanitized = sanitized.replace(/\s+on\w+='[^']*'/gi, '');

    /* Remove javascript: URLs */
    sanitized = sanitized.replace(/\s+href="javascript:[^"]*"/gi, ' href="#"');
    sanitized = sanitized.replace(/\s+href='javascript:[^']*'/gi, " href='#'");

    return sanitized.trim();
};

/* -------------------- Reusable Component to render HTML -------------------- */
export const HtmlRenderer: React.FC<HtmlRendererProps> = ({
    html,
    className = '',
    tag: Tag = 'div',
    style,
}) => {
    if (!html) return null;

    return (
        <Tag
            className={className}
            style={style}
            dangerouslySetInnerHTML={{__html: sanitizeHtml(html)}}
        />
    );
};

export default HtmlRenderer;
